import { render, staticRenderFns } from "./source.vue?vue&type=template&id=2fb4ecf1&scoped=true"
import script from "./source.vue?vue&type=script&lang=js"
export * from "./source.vue?vue&type=script&lang=js"
import style0 from "./source.vue?vue&type=style&index=0&id=2fb4ecf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4ecf1",
  null
  
)

export default component.exports